import React, { Fragment } from 'react'
import PagesHeading from '../pages-heding/PagesHeading'
import Placements from '../placements/Placements'
const PlacementPage = (props) => {
  return (
    <Fragment>
        <PagesHeading page_title={props.page_title}></PagesHeading>
        <Placements></Placements>
    </Fragment>
  )
}

export default PlacementPage